import {
    STATISTICS_DASHBOARD_ROUTE,
} from './constants';

import http from '../../../utils/httpService';

/**
 *
 * @param calendar
 */
const requestStatisticsDashBoard = (calendar) => {
  const route = STATISTICS_DASHBOARD_ROUTE + calendar;
  return  http.request(route, 'GET');
};

export {
    requestStatisticsDashBoard
};
